var _ = require('underscore');

/* Hate saying this but a BB collection created with a 'compound key' is prob easier here */
/* may want to keep sorted by page id x search for saving ? */

var TopDownResult = function( pageId, searchId, note, search ) {

    this.note = note;
    this.searchId = searchId;
    this.pageId = pageId;
    this.search = search; // ( for reference )
    this.hits = [];

    return this;

};


_.extend( TopDownResult.prototype, {

    getNote: function() {
        return this.note;
    },
    addHit: function( hit ) {
        this.hits.push( hit );
    },

    getPageId: function( ) {
        return this.pageId;
    },

    getHits: function() {
        return this.hits;
    },

    getSearch: function() {
        return this.search;
    },

    getSearchId: function() {
        return this.searchId;
    },

    getAppliedHits: function() {

        return this.getHits().filter( function( h ) {
            return h.get('isApplied');
        });

    }

});



module.exports = TopDownResult;


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/findAndRedact/models/searchResults/topDownResults/topDownResult.js
 ** module id = 665
 ** module chunks = 0
 **/